import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import useTranslation from '../../../../hooks/useTranslation'
import { Modal } from '../../../../components/layout/Modal'

interface FailWithShortModalProps {
  isFailWithShortModal: boolean
  setFailWithShortModal: Dispatch<SetStateAction<boolean>>
  handleScroll: () => void
}

export const FailWithShortModal = ({
  children,
  isFailWithShortModal,
  setFailWithShortModal,
  handleScroll,
}: PropsWithChildren<FailWithShortModalProps>) => {
  const { t } = useTranslation()
  
  return (
    <>
      <Modal isModal={isFailWithShortModal}>
        <div className="bg-white w-[335px] h-auto p-[20px] border-t rounded-t-[20px]">
          <div className="flex flex-col items-center justify-center h-full gap-[24px]">
            <p className="font-bold text-[18px]">
              {t('productVideoEditor.failWithShortModal.title')}
            </p>
            <div className="flex flex-col leading-[22px]">
              <p className="text-[14px]">
                {t('productVideoEditor.failWithShortModal.description')}
              </p>
              <p className=" text-[14px] text-center my-6">
                {t('productVideoEditor.failWithShortModal.instructions')}
              </p>
            </div>
          </div>
        </div>
        <div className="w-[335px] text-[14px]  h-[60px]  flex justify-center items-center">
          <button
            className=" w-[50%] h-full text-black bg-[#EEF1F7] rounded-bl-[20px] border-b border-[#EEF1F7] "
            onClick={() => {
              setFailWithShortModal((prev) => !prev)
              handleScroll()
            }}
          >
            {t('common.cancel')}
          </button>
          <button
            className="text-white w-[50%] h-full bg-main rounded-br-[20px] border-b border-main font-bold"
            onClick={() => {
              setFailWithShortModal((prev) => !prev)
            }}
          >
            <a
              className="w-full h-full flex items-center justify-center" // 추가
              href={`${process.env.REACT_APP_URL}/shortform-price-guide?payment=true&close=true`}
              target="_blank"
              rel="noreferrer"
            >
              <span>{t('productVideoEditor.failWithShortModal.chargeCash')}</span>
            </a>
          </button>
        </div>
      </Modal>
    </>
  )
}
